import React, { Component } from 'react';
import RadioOption from './RadioOption';
import './RadioGroup.css';

class RadioGroup extends Component {

    constructor(props) {
        super(props);

        this.state = {
          selected: props.value || {
            label: '',
            value: ''
          }
        }
        this._onChanged = this._onChanged.bind(this);
    }

    UNSAFE_componentWillReceiveProps (newProps) {
      if (newProps.value && newProps.value !== this.state.selected) {
          this.setState({ selected: newProps.value });
      } else if (!newProps.value) {
          this.setState({
              selected: {
                  label: '',
                  value: ''
              }
          });
      }
    }

    setValue (value) {
        let newState = {
            selected: value
        };
        this.fireChangeEvent(newState);
        this.setState(newState);
    }

    fireChangeEvent (newState) {
      if (newState.selected !== this.state.selected && this.props.onChange) {
          this.props.onChange(newState.selected);
      }
    }

    _onChanged(event, value) {
        this.setValue(value);
    }

    render() {
        return (
            <div className="RadioGroup">
                {!this.props.label ? null : <span className="RadioGroup-title">{this.props.label}</span>}
                {this.props.options && this.props.options.map ? this.props.options.map(option => <RadioOption value={option} onChange={this._onChanged} checked={option === this.state.selected} key={option.value}><span>{option.label}</span> {option.description ? <span className="description">{option.description}</span> : null} </RadioOption>) : null}
            </div>
        );
    }
}

export default RadioGroup;


// WEBPACK FOOTER //
// ./src/RadioGroup.js